var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.722 1a3.26 3.26 0 00-2.316.962L11.02 4.347l-.383-.383a.9.9 0 10-1.272 1.272l.383.384v.001l.052.053c-.626.604-4.608 4.444-5.482 5.317-.756.756-1.2 1.361-1.46 1.927-.259.566-.305 1.075-.333 1.417-.028.342-.04.517-.176.819-.137.302-.429.747-1.088 1.413a.9.9 0 00.004 1.27l.9.9a.9.9 0 001.262.01c1.253-1.212 1.493-1.123 2.206-1.213.356-.045.858-.118 1.422-.387s1.18-.712 1.946-1.453a.9.9 0 00.008-.011c.886-.886 4.891-4.745 5.485-5.317l.27.27a.9.9 0 101.273-1.272l-.383-.384 2.385-2.387a3.27 3.27 0 000-4.631A3.267 3.267 0 0015.722 1zm-4.65 5.947h.002l2.144 2.146c-.617.595-4.529 4.364-5.482 5.317-.667.644-1.13.955-1.457 1.111-.33.157-.535.184-.874.227-.434.055-1.095.297-1.855.733.115-.182.36-.414.438-.585.257-.568.303-1.075.33-1.415.028-.34.039-.513.176-.812.138-.3.433-.742 1.095-1.405.799-.798 4.877-4.732 5.483-5.317z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/color-picker.baaeb659cfc2e4010c5d16a3fdf49fd0.svg";
export { ForwardRef as ReactComponent };